import React from 'react';
import PropTypes from 'prop-types';
import './main.less';

import Animate from '../animation';

import ContentHead from './components/content-head/main';
import ContentBody from './components/content-body/main';

function PageContainer({ name, tabs, children }) {
	return (
		<Animate>
			<div className='page-container'>
				<ContentHead name={name} tabs={tabs} />
				<ContentBody>{children}</ContentBody>
			</div>
		</Animate>
	);
}

PageContainer.propTypes = {
	name: PropTypes.string.isRequired,
	tabs: PropTypes.arrayOf(PropTypes.exact({
		href: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		permission: PropTypes.string
	}))
};

export default PageContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/page-container/main.js